import { jsx as _jsx } from "react/jsx-runtime";
// Importing theme
import { createTheme } from '../theme';
// Importing 3rd party dependencies
import * as React from 'react';
import { ThemeProvider } from '@mui/material/styles';
function PlayerThemeProvider({ children }) {
    const theme = createTheme({}, 'de');
    return _jsx(ThemeProvider, { theme: theme, children: children });
}
export { PlayerThemeProvider as ThemeProvider };
